/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISoftwareEscrowAgreementTermsQueryVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
}>;

export type ISoftwareEscrowAgreementTermsQuery = {
  __typename?: 'Query';
  softwareEscrowTerms: {
    __typename?: 'SoftwareEscrow';
    agreement: {
      __typename?: 'Agreement';
      terms?: string | null;
      termsDownloadPdfUrl?: string | null;
      termsSignedDownloadPdfUrl?: string | null;
      termsDownloadDocxUrl?: string | null;
    };
  };
};

export const SoftwareEscrowAgreementTermsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'softwareEscrowAgreementTerms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'softwareEscrowTerms' },
            name: { kind: 'Name', value: 'softwareEscrow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'softwareEscrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agreement' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'terms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'termsDownloadPdfUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'termsSignedDownloadPdfUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'termsDownloadDocxUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISoftwareEscrowAgreementTermsQuery, ISoftwareEscrowAgreementTermsQueryVariables>;
